import { useState } from 'react';
import type { FC } from 'react';
import BasePrimaryNavItem from './BasePrimaryNavItem';
import { Tooltip } from '@mui/material';

declare interface Props {
  isPopover?: boolean;
}
const HelpItem: FC<React.PropsWithChildren<Props>> = (props) => {
  const [open] = useState<boolean>(false);

  const content = (
    <>
      <p className="global-nav__section-title">Help</p>
      <div className="global-nav__item">
        <div className="global-nav__item-link">
          <a href="https://bfgsupply.lessonly.com/lesson/1521148-sfa-ordering-software" target="_blank">
            Training
          </a>
        </div>
        <div className="global-nav__item-link">
          <a href="mailto:itdept@bfgsupply.com?subject=SFA%20Support%20Request">Open a Ticket</a>
        </div>
        <div className="global-nav__item-link">
          <Tooltip title="(440) 834-1883" placement="right">
            <a href="tel:440.834.1883">Call Support</a>
          </Tooltip>
        </div>
      </div>
    </>
  );

  return (
    <>
      <BasePrimaryNavItem anchorEl="Help" isPopover={props.isPopover} isOpen={open}>
        {content}
      </BasePrimaryNavItem>
    </>
  );
};

export default HelpItem;
